<div class="unauthorized-container">
  <div class="unauthorized-content">
    <!-- Vericure Logo -->
    <div class="logo-container">
      <img src="assets/vericure-logo-cobalt.png" alt="Vericure" class="vericure-logo">
    </div>
    
    <!-- Header with Icon -->
    <div class="header-section">
      <h1>{{ 'UnauthorizedAccessDenied' | t }}</h1>
      <p class="subtitle">{{ 'UnauthorizedYouAreNotAuthorizedToUse' | t }}</p>
    </div>

    <!-- User Information Section -->
    <div class="user-info-section" *ngIf="userAccount">
      <h3>{{ 'UnauthorizedLoggedInUserInformation' | t }}</h3>
      <div class="user-details">
        <div class="user-avatar">
          <i class="fa-solid fa-user"></i>
        </div>
        <div class="user-text">
          <p class="user-name">{{ userName }}</p>
          <p class="user-email">{{ userEmail }}</p>
        </div>
      </div>
    </div>

    <!-- Message Section -->
    <div class="message-section">
      <h3>{{ 'UnauthorizedWhyAmISeeingThisPage' | t }}</h3>
      <p>{{ 'UnauthorizedYouHaveSuccessfullyAuthenticatedWithYour' | t }}</p>
      <ul>
        <li>{{ 'UnauthorizedYourAccountHasnTBeenGranted' | t }}</li>
        <li>{{ 'UnauthorizedYourAccessHasBeenRevokedOr' | t }}</li>
        <li>{{ 'UnauthorizedYourAccountIsNotPartOf' | t }}</li>
      </ul>
      <!-- PRIMARY ROUTING STAYS. This page is an ACCESS REQUEST, not a product
           fault: only the customer's own administrator can grant access, so
           pointing at Vericure Support first would send people to someone who
           cannot help them. Our contact is added as the secondary path, for the
           case where the user believes the refusal itself is wrong. -->
      <p class="contact-info">{{ 'UnauthorizedPleaseContactYourSystemAdministratorOr' | t }}</p>
      <p class="contact-info secondary">{{ 'UnauthorizedIfYouBelieveThisIsAn' | t }}<a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
        or <a [href]="'tel:' + supportPhoneTel">{{ supportPhone }}</a>.
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-primary" (click)="onLogout()">
        <i class="fa-solid fa-sign-out-alt"></i>{{ 'UnauthorizedLogout' | t }}</button>
    </div>
  </div>
</div>
